/**
 * @jsxRuntime classic
 * @jsx jsx
 * @jsxFrag
 */
import React from 'react';

import { css as cssUnbounded, jsx, keyframes } from '@compiled/react';

const shimmerAnimation = keyframes({
	'0%': {
		WebkitMaskPosition: '200% 0',
		maskPosition: '200% 0',
	},
	'100%': {
		WebkitMaskPosition: '-200% 0',
		maskPosition: '-200% 0',
	},
});

const shimmerIconStyle = cssUnbounded({
	display: 'inline-flex',
	WebkitMaskImage:
		'linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.75) 30%, rgba(0,0,0,0.75) 70%, rgba(0,0,0,0.4) 100%)',
	maskImage:
		'linear-gradient(90deg, rgba(0,0,0,0.4) 0%, rgba(0,0,0,0.75) 30%, rgba(0,0,0,0.75) 70%, rgba(0,0,0,0.4) 100%)',
	WebkitMaskSize: '200% 100%',
	maskSize: '200% 100%',
	animation: `${shimmerAnimation} 1.7s linear infinite`,
});

type ShimmerIconProps = {
	children: React.ReactNode;
};

export const ShimmerIcon = ({ children }: ShimmerIconProps): JSX.Element => {
	return <div css={shimmerIconStyle}>{children}</div>;
};
